/*
  Badache — recherche prédictive
  Branche l'API native Shopify /search/suggest.json sur les champs de recherche
  du header (desktop + mobile). Produits uniquement, photo + nom + prix.
  Aucune dépendance, aucune application tierce.
*/
(function () {
  'use strict';

  var MIN_CHARS = 2;    // nombre de caractères avant de lancer une recherche
  var DELAI     = 180;  // ms d'attente après la dernière frappe
  var LIMITE    = 6;    // nombre de produits affichés

  var money = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  // /search/suggest.json renvoie le prix en EUROS sous forme de chaîne ("9.99"),
  // et non en centimes comme la plupart des autres API Shopify.
  function prix(valeur) {
    var n = parseFloat(String(valeur == null ? '' : valeur).replace(',', '.'));
    if (!isFinite(n)) return '';
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: money }).format(n);
    } catch (e) {
      return n.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function vignette(url) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=120' : url + '?width=120';
  }

  function echappe(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function brancher(input, conteneur) {
    if (!input || !conteneur || input.dataset.bdPsOn === '1') return;
    input.dataset.bdPsOn = '1';
    input.setAttribute('autocomplete', 'off');

    var panneau = document.createElement('div');
    panneau.className = 'bd-ps';
    panneau.setAttribute('role', 'listbox');
    panneau.hidden = true;
    conteneur.appendChild(panneau);

    var timer = null;
    var ctrl = null;
    var index = -1;
    var liens = [];

    function fermer() {
      panneau.hidden = true;
      panneau.innerHTML = '';
      index = -1;
      liens = [];
      input.setAttribute('aria-expanded', 'false');
    }

    function rendre(produits, terme) {
      if (!produits.length) {
        panneau.innerHTML = '<p class="bd-ps-vide">Aucun produit ne correspond à «&nbsp;' + echappe(terme) + '&nbsp;»</p>';
        panneau.hidden = false;
        liens = [];
        return;
      }
      var html = '<ul class="bd-ps-liste">';
      produits.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? vignette(p.featured_image.url) : '';
        html += '<li><a class="bd-ps-item" href="' + echappe(p.url) + '" role="option">'
             +    '<span class="bd-ps-img">'
             +      (img ? '<img src="' + echappe(img) + '" alt="" loading="lazy" width="48" height="48">' : '')
             +    '</span>'
             +    '<span class="bd-ps-txt">'
             +      '<span class="bd-ps-nom">' + echappe(p.title) + '</span>'
             +      '<span class="bd-ps-prix">' + prix(p.price) + '</span>'
             +    '</span>'
             +  '</a></li>';
      });
      html += '</ul>';
      html += '<a class="bd-ps-tout" href="/search?q=' + encodeURIComponent(terme) + '&type=product">'
           +    'Voir tous les résultats'
           +    '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3 7h8m0 0L7.5 3.5M11 7l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
           +  '</a>';
      panneau.innerHTML = html;
      panneau.hidden = false;
      liens = Array.prototype.slice.call(panneau.querySelectorAll('a'));
      index = -1;
      input.setAttribute('aria-expanded', 'true');
    }

    function chercher(terme) {
      if (ctrl) ctrl.abort();
      ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(terme)
              + '&resources[type]=product'
              + '&resources[limit]=' + LIMITE
              + '&resources[options][unavailable_products]=show'
              + '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var p = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          rendre(p, terme);
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') fermer(); });
    }

    input.addEventListener('input', function () {
      var terme = input.value.trim();
      clearTimeout(timer);
      if (terme.length < MIN_CHARS) { fermer(); return; }
      timer = setTimeout(function () { chercher(terme); }, DELAI);
    });

    input.addEventListener('keydown', function (e) {
      if (panneau.hidden || !liens.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        index += (e.key === 'ArrowDown' ? 1 : -1);
        if (index < 0) index = liens.length - 1;
        if (index >= liens.length) index = 0;
        liens.forEach(function (a, i) { a.classList.toggle('is-actif', i === index); });
        liens[index].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && index > -1) {
        e.preventDefault();
        liens[index].click();
      } else if (e.key === 'Escape') {
        fermer();
        input.blur();
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && panneau.innerHTML) panneau.hidden = false;
    });

    document.addEventListener('click', function (e) {
      if (!conteneur.contains(e.target)) fermer();
    });
  }

  function init() {
    // desktop : le formulaire lui-même sert de conteneur positionné
    var d = document.querySelector('.bd-header-search-input');
    if (d) brancher(d, d.closest('.bd-header-search'));

    // mobile : le bloc de recherche du menu
    var m = document.querySelector('[data-bd-mobile-search-input]');
    if (m) brancher(m, m.closest('.bd-header-mobile-search'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
